import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import brianPortrait from "../assets/images/PortraitBeach.jpg";
import districtMap from "../assets/images/HD_32.jpg";
import slideOnePhoto from "../assets/images/Slide1.jpg";
import slideTwoPhoto from "../assets/images/Slide2.jpg";
import slideThreePhoto from "../assets/images/CarouselBorder.jpg";
import slideFourPhoto from "../assets/images/Slide4.jpg";
import slideFivePhoto from "../assets/images/CarouselCulture.jpg";
import slideSixPhoto from "../assets/images/CarousalSchools.jpg";
import slideSevenPhoto from "../assets/images/Slide7.jpg";
import slideEightPhoto from "../assets/images/BacksTheBlue.png";
import slideNinePhoto from "../assets/images/NRA.png";
import slideElevenPhoto from "../assets/images/IllegalImmigration.png";
import aifEndorsement from "../assets/images/AIF.JPG";
import afpActionEndorsement from "../assets/images/AFP.jpg";
import brianHodgersScheinerEndorsement from "../assets/images/brian-hodgers-scheiner-endorsement-graphic.jpg";
import fopEndorsement from "../assets/images/brian-hodgers-fop-endorsement-graphic-a.jpg";
import businessVoiceEndorsement from "../assets/images/Business Voice.jpg";
import chamberEndorsement from "../assets/images/chamber_of_commerce.JPG";
import conservativeWatchEndorsement from "../assets/images/conservative_watch.JPG";
import daveWeldonEndorsement from "../assets/images/dave-weldon-endorsement-graphic.jpg";
import firefightersEndorsement from "../assets/images/FireFighters.jpg";
import floridaAbcEndorsement from "../assets/images/florida-abc-endorsement-graphic.jpg";
import floridaFamilyActionEndorsement from "../assets/images/Fl Fam Action.jpg";
import floridaRealtorsEndorsement from "../assets/images/florida_realtors.jpg";
import mikeHaridopolosEndorsement from "../assets/images/mike-haridopolos-endorsement-graphic-a (002).jpg";
import nraEndorsement from "../assets/images/NRA.jpg";
import pbaEndorsement from "../assets/images/PBA.jpg";
import rockledgeEndorsement from "../assets/images/Rockledge.jpg";
import sadoffEndorsement from "../assets/images/Sadoff.jpg";
import scottEllisEndorsement from "../assets/images/scott-ellis-endorsement-graphic.jpg";
import spaceCoastYoungRepublicansEndorsement from "../assets/images/SpCoastYR.jpeg";
import spaceCoastRealtorsEndorsement from "../assets/images/space_coast_association_of_realtors.jpg";
import wayneIveyEndorsement from "../assets/images/wayne-ivey-endorsement-graphic.jpg";

const priorities = [
  {
    title: "Lower Insurance Costs",
    text: "Brian will keep pushing for legal reforms, stronger anti-fraud enforcement, and smarter building standards so families stop absorbing runaway premium increases."
  },
  {
    title: "Cut the Tax Burden",
    text: "He supports lowering property taxes, ending unnecessary taxes on insurance policies, and demanding that government live within its means."
  },
  {
    title: "Protect the Lagoon",
    text: "Brevard's waterways are core to the local economy and quality of life. Brian supports basin management, stormwater projects, and practical septic-to-sewer solutions."
  },
  {
    title: "Secure the Border",
    text: "Brian backs stronger immigration enforcement, support for law enforcement, and ending state-level incentives that attract illegal immigration."
  },
  {
    title: "Fix Transportation",
    text: "Population growth has outpaced road capacity. Brian wants targeted infrastructure investment, better traffic flow, and safer response routes for first responders."
  },
  {
    title: "Defend Families and Schools",
    text: "Brian is pro-life, pro-family, pro-Second Amendment, and supports school choice, parental rights, and stronger campus safety."
  }
];

const endorsementCards = [
  {
    name: "Wayne Ivey, Brevard County Sheriff",
    image: wayneIveyEndorsement,
    featured: true,
    description: "Endorsed by Brevard County Sheriff Wayne Ivey."
  },
  {
    name: "Mike Haridopolos, Congressman",
    image: mikeHaridopolosEndorsement,
    featured: true,
    description: "Endorsed by Congressman Mike Haridopolos."
  },
  {
    name: "National Rifle Association",
    image: nraEndorsement,
    featured: true,
    description: "Endorsed by the National Rifle Association."
  },
  {
    name: "Americans for Prosperity Action",
    image: afpActionEndorsement,
    featured: true,
    description: "Endorsed by Americans for Prosperity Action."
  },
  {
    name: "Florida Family Action",
    image: floridaFamilyActionEndorsement,
    featured: true,
    description: "Endorsed by Florida Family Action."
  },
  {
    name: "ABC Florida East Coast",
    image: floridaAbcEndorsement,
    featured: true,
    description: "Endorsed by Associated Builders and Contractors Florida East Coast."
  },
  {
    name: "Florida State Fraternal Order of Police",
    image: fopEndorsement,
    featured: true,
    description: "Endorsed by the Florida State Fraternal Order of Police."
  },
  {
    name: "Florida Police Benevolent Association",
    image: pbaEndorsement,
    featured: true,
    description: "Officially endorsed by the Florida Police Benevolent Association."
  },
  {
    name: "Florida Professional Firefighters",
    image: firefightersEndorsement,
    featured: true,
    description: "Endorsed by Florida Professional Firefighters."
  },
  {
    name: "Scott Ellis, Former Brevard County Clerk of Courts",
    image: scottEllisEndorsement,
    featured: true,
    description: "Endorsed by former Brevard County Clerk of Courts Scott Ellis."
  },
  {
    name: "Rachel Sadoff, Brevard Clerk of Courts & Comptroller",
    image: sadoffEndorsement,
    featured: true,
    description: "Endorsed by Brevard Clerk of Courts & Comptroller Rachel Sadoff."
  },
  {
    name: "Tom Price, Mayor of Rockledge",
    image: rockledgeEndorsement,
    featured: true,
    description: "Endorsed by Rockledge Mayor Tom Price."
  },
  {
    name: "William Scheiner, State Attorney",
    image: brianHodgersScheinerEndorsement,
    featured: true,
    description: "Endorsed by William Scheiner, State Attorney for the 18th Judicial Circuit."
  },
  {
    name: "Dr. Dave Weldon, Former U.S. Congressman",
    image: daveWeldonEndorsement,
    featured: true,
    description: "Endorsed by former U.S. Congressman Dr. Dave Weldon."
  },
  {
    name: "Florida Realtors",
    image: floridaRealtorsEndorsement,
    description: "Industry support for affordability and property-rights priorities."
  },
  {
    name: "Space Coast Association of Realtors",
    image: spaceCoastRealtorsEndorsement,
    description: "Local support from real estate leaders in the region."
  },
  {
    name: "Space Coast Young Republicans",
    image: spaceCoastYoungRepublicansEndorsement,
    featured: true,
    description: "Endorsed by Space Coast Young Republicans."
  },
  {
    name: "Associated Industries of Florida",
    image: aifEndorsement,
    description: "Statewide business support for practical conservative leadership."
  },
  {
    name: "Business Voice of Florida's Space Coast",
    image: businessVoiceEndorsement,
    description: "Local business backing from the Space Coast."
  },
  {
    name: "Conservative Watch USA",
    image: conservativeWatchEndorsement,
    description: "Support for dependable conservative results."
  },
  {
    name: "Florida Chamber of Commerce",
    image: chamberEndorsement,
    description: "Pro-growth leadership recognized by Florida business advocates."
  }
];

const credibilityStats = [
  {
    value: "30+",
    label: "Years in business and community leadership"
  },
  {
    value: "100%",
    label: "Focused on District 32 kitchen-table issues"
  },
  {
    value: String(endorsementCards.length),
    label: "Major endorsements highlighted by the campaign"
  }
];

const leadershipPoints = [
  "Proven small business and insurance industry experience",
  "Deep roots in Brevard civic boards and local advocacy",
  "Clear support for parental rights, public safety, and lower taxes"
];

const momentumSlides = [
  {
    image: wayneIveyEndorsement,
    alt: "Wayne Ivey endorsement",
    title: "Endorsed by Brevard County Sheriff Wayne Ivey.",
    eyebrow: "New endorsement"
  },
  {
    image: mikeHaridopolosEndorsement,
    alt: "Mike Haridopolos endorsement",
    title: "Endorsed by Congressman Mike Haridopolos.",
    eyebrow: "New endorsement"
  },
  {
    image: nraEndorsement,
    alt: "National Rifle Association endorsement",
    title: "Endorsed by the National Rifle Association.",
    eyebrow: "New endorsement"
  },
  {
    image: afpActionEndorsement,
    alt: "Americans for Prosperity Action endorsement",
    title: "Endorsed by Americans for Prosperity Action.",
    eyebrow: "New endorsement"
  },
  {
    image: floridaFamilyActionEndorsement,
    alt: "Florida Family Action endorsement",
    title: "Endorsed by Florida Family Action.",
    eyebrow: "New endorsement"
  },
  {
    image: floridaAbcEndorsement,
    alt: "ABC Florida East Coast endorsement",
    title: "Endorsed by ABC Florida East Coast.",
    eyebrow: "New endorsement"
  },
  {
    image: fopEndorsement,
    alt: "Florida State Fraternal Order of Police endorsement",
    title: "Endorsed by the Florida State Fraternal Order of Police.",
    eyebrow: "New endorsement"
  },
  {
    image: pbaEndorsement,
    alt: "Florida Police Benevolent Association endorsement",
    title: "Officially endorsed by the Florida Police Benevolent Association.",
    eyebrow: "New endorsement"
  },
  {
    image: firefightersEndorsement,
    alt: "Florida Professional Firefighters endorsement",
    title: "Endorsed by Florida Professional Firefighters.",
    eyebrow: "New endorsement"
  },
  {
    image: scottEllisEndorsement,
    alt: "Scott Ellis endorsement",
    title: "Endorsed by former Brevard County Clerk of Courts Scott Ellis.",
    eyebrow: "New endorsement"
  },
  {
    image: sadoffEndorsement,
    alt: "Rachel Sadoff endorsement",
    title: "Endorsed by Brevard Clerk of Courts & Comptroller Rachel Sadoff.",
    eyebrow: "New endorsement"
  },
  {
    image: rockledgeEndorsement,
    alt: "Tom Price endorsement",
    title: "Endorsed by Rockledge Mayor Tom Price.",
    eyebrow: "New endorsement"
  },
  {
    image: brianHodgersScheinerEndorsement,
    alt: "William Scheiner endorsement",
    title: "Endorsed by William Scheiner, State Attorney for the 18th Judicial Circuit.",
    eyebrow: "New endorsement"
  },
  {
    image: daveWeldonEndorsement,
    alt: "Dr. Dave Weldon endorsement",
    title: "Endorsed by former U.S. Congressman Dr. Dave Weldon.",
    eyebrow: "New endorsement"
  },
  {
    image: floridaRealtorsEndorsement,
    alt: "Florida Realtors endorsement",
    title: "Florida Realtors",
    eyebrow: "New endorsement"
  },
  {
    image: spaceCoastRealtorsEndorsement,
    alt: "Space Coast Association of Realtors endorsement",
    title: "Space Coast Association of Realtors",
    eyebrow: "New endorsement"
  },
  {
    image: spaceCoastYoungRepublicansEndorsement,
    alt: "Space Coast Young Republicans endorsement",
    title: "Endorsed by Space Coast Young Republicans.",
    eyebrow: "New endorsement"
  },
  {
    image: slideOnePhoto,
    alt: "Insurance reform",
    title: "Lower insurance costs for Florida families."
  },
  {
    image: slideTwoPhoto,
    alt: "Lagoon protection",
    title: "Protect the Indian River Lagoon and Brevard waterways."
  },
  {
    image: slideThreePhoto,
    alt: "Secure the border",
    title: "Stand with strong border enforcement and public safety."
  },
  {
    image: slideFourPhoto,
    alt: "Transportation priorities",
    title: "Address transportation challenges with practical state action."
  },
  {
    image: slideFivePhoto,
    alt: "Culture issues",
    title: "Defend faith, family, freedom, and common sense."
  },
  {
    image: slideSixPhoto,
    alt: "School choice",
    title: "Back school choice and stronger parental control."
  },
  {
    image: slideSevenPhoto,
    alt: "Family values",
    title: "Keep traditional family values at the center of policy."
  },
  {
    image: slideEightPhoto,
    alt: "Backs the blue",
    title: "Support law enforcement and safe communities."
  },
  {
    image: slideNinePhoto,
    alt: "NRA support",
    title: "Protect constitutional rights, including the Second Amendment."
  },
  {
    image: slideElevenPhoto,
    alt: "Immigration policy",
    title: "Put Florida families first in state policy."
  }
];

const HomePage = () => {
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false
  };

  return (
    <div className="page-shell">
      <section className="hero-section">
        <div className="hero-copy">
          <p className="section-kicker">Brian Hodgers for State House District 32</p>
          <div className="hero-badges">
            <span className="hero-badge">Conservative</span>
            <span className="hero-badge">Business owner</span>
            <span className="hero-badge">Brevard County</span>
          </div>
          <h1>Conservative leadership for Brevard County and Florida families.</h1>
          <p className="hero-text">
            Husband, father, small business owner, and lifelong Floridian focused on lower costs,
            safer communities, stronger schools, and protecting the freedoms that make Florida work.
          </p>
          <div className="hero-actions">
            <a
              className="button button-primary"
              href="https://secure.anedot.com/brian-hodgers-campaign-f3acd9b2-bee5-41d0-8d27-4b6d9291fadf/donate"
              target="_blank"
              rel="noreferrer"
            >
              Donate
            </a>
            <Link className="button button-secondary" to="/about">
              Meet Brian
            </Link>
          </div>
          <div className="hero-quote">
            <span className="hero-quote-mark">"</span>
            <p>
              Florida families deserve a representative who will protect freedom, strengthen the
              local economy, and fight for practical conservative results.
            </p>
          </div>
        </div>
        <div className="hero-portrait-wrap">
          <div className="hero-portrait-frame">
            <img src={brianPortrait} alt="Brian Hodgers on the beach" className="hero-portrait" />
          </div>
          <div className="hero-support-card">
            <p className="hero-support-label">Campaign focus</p>
            <p className="hero-support-text">
              Lower costs. Safer communities. Stronger schools. More accountability in Tallahassee.
            </p>
          </div>
        </div>
      </section>

      <section className="message-band">
        {credibilityStats.map((stat) => (
          <div key={stat.label} className="message-band-item">
            <span className="message-band-value">{stat.value}</span>
            <p>{stat.label}</p>
          </div>
        ))}
      </section>

      <section className="content-panel district-panel">
        <div className="district-layout">
          <div className="district-copy">
            <p className="section-kicker">The district</p>
            <h2>Focused on the communities that make up House District 32.</h2>
            <p className="section-body">
              This race is local. The campaign is built around the neighborhoods, families, employers,
              and community institutions that define District 32 and shape daily life across Brevard
              County.
            </p>
            <p className="section-body">
              The map helps anchor the campaign in place and makes clear that Brian is running to serve
              a real district with real transportation, affordability, public safety, and school-choice
              concerns.
            </p>
          </div>
          <div className="district-map-card">
            <img src={districtMap} alt="Map of Florida House District 32" className="district-map-image" />
            <p className="district-map-caption">Florida House District 32</p>
          </div>
        </div>
      </section>

      <section className="content-panel story-panel">
        <div className="story-showcase">
          <div className="panel-heading story-heading">
            <p className="section-kicker">About the campaign</p>
            <h2>A serious campaign built around local credibility.</h2>
          </div>
          <div className="story-copy">
            <p>
              Brian Hodgers is not running as a generic political brand. He is a longtime Brevard County
              business owner, a civic leader, and a conservative grounded in the day-to-day pressures that
              families and employers are actually dealing with.
            </p>
            <p>
              That means a campaign centered on rising insurance costs, transportation strain, school
              choice, safer communities, and the practical stewardship required to protect Florida's
              economic and cultural strength.
            </p>
          </div>
          <div className="story-accent">
            <p className="story-accent-kicker">Why this race matters</p>
            <p>
              District 32 needs a representative who understands both the private sector and the local
              institutions that keep Brevard moving.
            </p>
          </div>
        </div>
        <div className="story-sidecar">
          <div className="story-card story-card-emphasis">
            <h3>What Brian brings</h3>
            <ul className="check-list">
              {leadershipPoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <Link className="text-link" to="/about">
              Read Brian's full story
            </Link>
          </div>
          <div className="story-mini-panel">
            <span className="message-band-label">Built for District 32</span>
            <p>Focused on affordability, freedom, public safety, infrastructure, and local quality of life.</p>
          </div>
        </div>
      </section>

      <section className="content-panel priorities-panel">
        <div className="panel-heading">
          <p className="section-kicker">Priorities</p>
          <h2>Fighting for the issues that shape daily life in District 32.</h2>
        </div>
        <div className="priority-grid">
          {priorities.map((priority) => (
            <article key={priority.title} className="priority-card">
              <h3>{priority.title}</h3>
              <p>{priority.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="content-panel media-panel">
        <div className="panel-heading">
          <p className="section-kicker">On the trail</p>
          <h2>Campaign momentum across the district.</h2>
        </div>
        <Slider {...carouselSettings}>
          {momentumSlides.map((slide) => (
            <div key={slide.title} className="campaign-slide">
              {slide.image ? (
                <>
                  <img src={slide.image} alt={slide.alt} className="campaign-slide-image" />
                  <div className="campaign-slide-overlay">
                    <p>{slide.title}</p>
                  </div>
                </>
              ) : (
                <div className="campaign-slide-placeholder">
                  <span className="campaign-slide-eyebrow">{slide.eyebrow}</span>
                  <p>{slide.title}</p>
                </div>
              )}
            </div>
          ))}
        </Slider>
      </section>

      <section className="content-panel support-panel">
        <div className="support-layout">
          <div className="panel-heading support-copy">
            <p className="section-kicker">Endorsements</p>
            <h2>Backed by conservative leaders and organizations.</h2>
            <p className="support-text">
              The campaign is earning support from business, grassroots, and civic organizations that
              want disciplined leadership and real conservative follow-through.
            </p>
            <div className="section-actions">
              <Link className="button button-secondary button-dark" to="/endorsements">
                View endorsements
              </Link>
            </div>
          </div>
          <div className="endorsement-gallery">
            {endorsementCards.map((endorsement) => (
              <article
                key={endorsement.name}
                className={`endorsement-card ${endorsement.featured ? "endorsement-card-featured" : ""}`}
              >
                {endorsement.image ? (
                  <img
                    src={endorsement.image}
                    alt={endorsement.name}
                    className="endorsement-card-image"
                  />
                ) : (
                  <div className="endorsement-card-placeholder">
                    <span className="endorsement-card-label">New endorsement</span>
                    <h3>{endorsement.name}</h3>
                    <p>{endorsement.description}</p>
                  </div>
                )}
                <div className="endorsement-card-body">
                  <h3>{endorsement.name}</h3>
                  <p>{endorsement.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="closing-cta">
        <p className="section-kicker">Join the campaign</p>
        <h2>Help Brian take conservative results to Tallahassee.</h2>
        <p>
          Every contribution and every supporter helps build the grassroots campaign needed to win
          District 32.
        </p>
        <div className="hero-actions">
          <a
            className="button button-primary"
            href="https://secure.anedot.com/brian-hodgers-campaign-f3acd9b2-bee5-41d0-8d27-4b6d9291fadf/donate"
            target="_blank"
            rel="noreferrer"
          >
            Donate today
          </a>
          <Link className="button button-secondary" to="/contact">
            Contact the campaign
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
